import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { BijlageTemplate } from '../../../templates/types/BijlageTemplate'
import type { BijlageTemplatesForEntity } from '../types/BijlageTemplatesForEntity'

export { fetchBijlageTemplatesForEntity, initialState }

const initialState: BijlageTemplatesForEntity = {
  data: [],
}

const fetchBijlageTemplatesForEntity = async ({
  id,
  type,
}: Entity): Promise<BijlageTemplate[]> => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/bijlagetemplate`,
    method: 'GET',
  })

  return data
}
